import { get } from "lodash";
import { useState } from "react";
import ProfileModal from "./Modal";
import { MdArrowDropDown } from "react-icons/md";

function Profile({ project, updateStatus }) {
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);

  const firstname = get(project, "contact.user.firstname", "");
  const lastname = get(project, "contact.user.lastname", "");
  const displayName = `${firstname} ${lastname}`.trim() || "";

  return (
    <>
      <div className="miltis-navbar__profile" onClick={onOpen}>
        {displayName}
        <MdArrowDropDown size={16} />
      </div>
      <ProfileModal
        open={open}
        updateStatus={updateStatus}
        onClose={onClose}
        project={project}
      />
    </>
  );
}

export default Profile;
